/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOListBankUssdRecord } from '../models/ApiResponseDTOListBankUssdRecord';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UssdApiService {

    /**
     * Get available USSD Banks
     * Retrieves a list of available USSD Banks.
     * @param operationId 
     * @returns ApiResponseDTOListBankUssdRecord OK
     * @throws ApiError
     */
    public static getAvailableUssdBanks(
operationId: string,
): CancelablePromise<ApiResponseDTOListBankUssdRecord> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operation/payment-link/{operationId}/ussd/banks',
            path: {
                'operationId': operationId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Get Available Banks for USSD
     * Retrieves a list of banks that have USSD available.
     * @returns ApiResponseDTOListBankUssdRecord OK
     * @throws ApiError
     */
    public static getAvailableBanksUssd(): CancelablePromise<ApiResponseDTOListBankUssdRecord> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/ussd/banks',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

}
